import { DMA_COUNTRIES, DmaCountry } from './dma-countries';
import { normaliseDmaCountry } from './normalise-dma-country';

/**
 * The agentic upload flow (PLT-5088) checks every proposed country key against `DMA_COUNTRIES`
 * before writing: the chat card, the propose tool and the batch-apply endpoint all use this. There
 * is intentionally no "Others" / "Rest of the world" catch-all bucket: partial splits are expressed
 * by omitting keys, not by a residual row.
 */
const dmaCountryByLowercase: ReadonlyMap<string, DmaCountry> = new Map(
  DMA_COUNTRIES.map(country => [country.toLowerCase(), country] as const),
);

/**
 * Resolves a country key to its `DMA_COUNTRIES` spelling, or `null` if it is not a valid
 * operational-data country or region. A list name in any casing resolves to itself first, which is
 * how regions ("Europe") resolve: `normaliseDmaCountry` leaves them out on purpose, since a site
 * sits in one country, but operational data may be split by region. Anything else goes through
 * `normaliseDmaCountry`, which knows ISO codes and the alternative names reports use ("USA",
 * "Czech Republic").
 */
export function resolveOperationalDataCountry(key: string): DmaCountry | null {
  return dmaCountryByLowercase.get(key.trim().toLowerCase()) ?? normaliseDmaCountry(key) ?? null;
}

/** Whether `key` is a valid operational-data country or region. */
export function isValidOperationalDataCountry(key: string): boolean {
  return resolveOperationalDataCountry(key) !== null;
}
